import { PureComponent } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { LogsPaths, StatisticsPaths, SuppressionsPaths } from '../dictionaries/paths';

const isException = (url: string, prevUrl: string): boolean => {
    const noScrollUrl = [
        StatisticsPaths.StatisticsOverview,
        StatisticsPaths.StatisticsLog,
        StatisticsPaths.StatisticsInprogress,
        LogsPaths.LogsEmail,
        LogsPaths.LogsNotification,
        SuppressionsPaths.UnsubscribedSuppressions,
    ];

    return noScrollUrl.some((el) => url === el) && noScrollUrl.some((el) => prevUrl?.includes(el));
};

class ScrollIntoView extends PureComponent<RouteComponentProps> {
    componentDidMount = (): void => window.scrollTo(0, 0);

    componentDidUpdate = (prevProps): void => {
        if (isException(location.pathname, prevProps.location.pathname)) {
            return;
        }

        if (this.props.location.pathname !== prevProps.location.pathname) window.scrollTo(0, 0);
    };

    render = (): React.ReactNode => this.props.children;
}

export default withRouter(ScrollIntoView);
